import { Headers, RequestOptions, RequestOptionsArgs } from '@angular/http';

export class AuthOptions extends RequestOptions {
  constructor(opts?: RequestOptionsArgs) {
    super(opts);
    if (!this.headers) {
      this.headers = new Headers();
    }
  }

  setAuthentication(session: any) {
    if (session) {
      this.headers.append('Authorization', `Bearer ${session.token}`);
    }
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/services/base/auth.options.ts